import React from 'react';
import './policyTitle.scss';
import { useTranslation } from 'react-i18next';

const PolicyTitle = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='containerCollaborators'>
                <div className='titlePolicy'>
                    <text>{t('policy.title')}</text>
                </div>
            </div>
        </>



    );
}

export default PolicyTitle;
